<template>
    <div>
        <div class="content-caption dashed">
            <span>单据信息</span>
        </div>
        <div class="simple-form flex col-2">
            <div class="form-group center">
                <div class="form-label">
                    <label>标题</label>
                </div>
                <div class="form-value">
                    <span>{{voucher.title}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>入库单号：</label>
                </div>
                <div class="form-value">
                    <span>{{voucher.no}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>入库仓库：</label>
                </div>
                <div class="form-value">
                    <span>{{voucher.warehouseName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建时间：</label>
                </div>
                <div class="form-value">
                    <span>{{voucher.createTime}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>创建人：</label>
                </div>
                <div class="form-value">
                    <span>{{voucher.creatorName}}</span>
                </div>
            </div>
            <div class="form-group center">
                <div class="form-label">
                    <label>备注</label>
                </div>
                <div class="form-value">
                    <span>{{voucher.memo}}</span>
                </div>
            </div>
        </div>
        <div class="content-caption dashed">
            <span>入库耗材信息</span>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" :confKey="confKey" :configAuto="true" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <swb-result-table name="result_table" ref="result_table" :confKey="resultKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :btnColName="btnColName" :btnColTitle="btnColTitle" :btnColWidth="btnColWidth" :btnColFixed="btnColFixed" :height="500" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'
    import { getDevcGroupNameByCatId } from '../index'
    import { loadRetailerDevcGroupList } from '../retailer/asset-comn'

    import shopStuffApi from '../../api/shopStuff'

    export default {
        name: 'swb-shop-device-ioIn-voucher-lowCost-detail',
        desc: '耗材入库单详情',
        props: ['voucherId'],
        data: function () {
            return {
                confKey: "swb-shop-device-ioIn-voucher-lowCost-detail",
                resultKey: "swb-shop-device-ioIn-voucher-lowCost-detail",
                tableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: false, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）
                btnColName: null,//操作列名称（如果不设置就不显示操作列）
                btnColTitle: '操作',//操作列标题（默认：'操作'）
                btnColWidth: 200,//操作列宽度（默认：100）
                //
                btnColFixed: true, //操作列是否固定
                //
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                pageNumber: 1,
                //
                voucher: {},
                pagination: {},
                ioInItems: [],
                //排序、搜索
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {},
                },
                acctEnterWayMap: []
                //
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            this.acctEnterWayMap = getEnumMap("acctEnterWay", "value2text");
            //
            this.getVoucherInfo();
        },
        mounted() {
            this.setMounted();
        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {
                let self = this;
                // 分类分组
                loadRetailerDevcGroupList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            setMounted(){
                let self = this;
                //注册domSizeWatcher
                $(this.$el).addClass("overflow-hidden");
                //
                this.initResultTable();
            },
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                // let confColList = resultColConfCmp.getMetaColList();
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);// .getResultColConfRef()
                //
                let setColsMap = {
                    'groupName': function (row, colName, colValue, rowIndex, colConf) {
                        let devcGroup = self.getGoodsCatDevcGroupName(row.catId) || "";
                        //
                        return '<span>' + devcGroup + '</span>';
                    },
                    'imageUrl': function (row, colName, colValue, rowIndex, colConf) {
                        if(!Utils.isNoB(row.imageUrl)) {
                            return '<a href="#"><img style="height: 36px;width: 36px" src="' + row.imageUrl + '"/></a>';
                        } else {
                            return '<span></span>';
                        }
                    },
                    'acctEnterWay': function (row, colName, colValue, rowIndex, colConf) {
                        let acctEnterWay = self.acctEnterWayMap[row.acctEnterWay] || "";
                        //
                        return '<span>' + acctEnterWay + '</span>';
                    },
                };
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */setColsMap, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
//                    'imageUrl': function (row, colName, colValue, rowIndex, btnName) {
//                        self.viewImage(colValue);
//                    },
                    'actions': function (row, colName, colValue, rowIndex, btnName) {
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                //清除数据（如果已经渲染的数据与新的列不是一回事儿）
                //resultTable.clear();
                //同步使用新的自定义列信息
                //resultTable.initMeta(confColList);
                //设置新数据
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getGoodsCatDevcGroupName: function (catId) {
                return getDevcGroupNameByCatId(catId);
            },
            queryHandler(queryModel) {
                this.queryModel = queryModel;
                //
                this.getItems();
            },
            getVoucherInfo(){
                let self = this;
                let voucherId = self.voucherId;
                let theLoad = MsgBox.loading();
                shopStuffApi.getStuffIoVoucherById({id: voucherId}, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        self.voucher = result.data;
                        //
                        self.getItems();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getItems();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                //
                this.getItems();
            },
            getItems() {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                //
                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.voucherId = self.voucherId;
                //
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoad = MsgBox.loading();
                shopStuffApi.getStuffIoItemList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        let data = result.data;
                        self.ioInItems = data.rows || [];
                        //
                        let pagination = result.data.pagination;
                        self.pagination = pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        //
                        self.renderTable(self.ioInItems, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>
<style>
    .form-row.col .form-label {
        width: 143px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/ShopDeviceLowCost/ShopDeviceIoInVoucherLowCostDetail.vue